"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const view_1 = require("./view");
const react_rxk_1 = require("react-rxk");
exports.Select = react_rxk_1.componentToRx(view_1.ReactSelectViewNoRx, undefined, undefined, {
    error: { ignore: { observable: true, promise: true } },
    loading: { loading: true }
});



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/selector/select.js
// module id = 513
// module chunks = 0